

















import Vue from 'vue'
// @ts-ignore
import pdfvuer from 'pdfvuer'
import { Component, Prop, Watch } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import AppRadio from '@/components/AppRadio.vue'

@Component({
  components: {
    AppDialog,
    AppRadio,
    pdf: pdfvuer
  }
})
export default class AppFilePreview extends Vue {
  @Prop({ type: String }) readonly blobUrl!: string
  @Prop({ type: String }) readonly fileType!: string

  showDialog = false
  pdfData: any = null
  pdfNumPages = 0

  get type () {
    switch (this.fileType.toLowerCase()) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'bmp':
      case 'gif':
        return 'img'
      case 'pdf':
        return 'pdf'
      default:
        return ''
    }
  }

  @Watch('blobUrl')
  onFileChanged (val: string) {
    this.showDialog = !!val

    if (this.fileType === 'pdf') {
      this.handlePdf()
    }
  }

  closePreview () {
    this.showDialog = false
  }

  async handlePdf () {
    if (!this.blobUrl) {
      return
    }
    this.pdfData = pdfvuer.createLoadingTask(this.blobUrl)
    this.pdfData.then((pdf: any) => {
      this.pdfNumPages = pdf.numPages
    })
  }
}
